import React, { useState, useEffect, useCallback } from "react";
import { FaPen, FaTrash, FaTimes } from "react-icons/fa";
import "./SalaryRecordList.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import SalaryRecordLayout from "../../layouts/Admin/SalaryRecordLayout";

const SalaryRecordList = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <SalaryRecordLayout />
    </>
  );
};

export default SalaryRecordList;
